import type { GameMode } from "./GameMode.js";
import { Ruleset } from "./Ruleset.js";
import { BotType } from "./BotType.js";

import { KnownLobbySettings } from "./KnownLobbySettings.js";
import type { GameSettings } from "../../royalur/model/GameSettings.js";


/**
 * Lobby settings that may not include all information.
 */
export class ApproximateLobbySettings {
    private readonly mode: GameMode | null;
    private readonly ruleset: Ruleset | null;
    private readonly customGameSettings: GameSettings | null;
    private readonly botType: BotType | null;

    constructor(
        mode: GameMode | null,
        ruleset: Ruleset | null,
        customGameSettings: GameSettings | null,
        botType: BotType | null,
    ) {
        this.mode = mode;
        this.ruleset = ruleset;
        this.customGameSettings = customGameSettings;
        this.botType = botType;
    }

    getMode(): GameMode | null {
        return this.mode;
    }

    getRuleset(): Ruleset | null {
        if (this.ruleset !== null)
            return this.ruleset;
        if (this.customGameSettings !== null)
            return Ruleset.getBySettings(this.customGameSettings);
        return null;
    }

    getGameSettings(): GameSettings | null {
        if (this.ruleset !== null && this.ruleset.hasSettings())
            return this.ruleset.getSettings();

        return this.customGameSettings;
    }

    getCustomGameSettings(): GameSettings | null {
        return this.customGameSettings;
    }

    getBotType(): BotType | null {
        return this.botType;
    }

    toKnown(): KnownLobbySettings | null {
        if (this.mode === null || this.ruleset === null || this.customGameSettings === null)
            return null;

        return new KnownLobbySettings(
            this.mode,
            this.ruleset,
            this.customGameSettings,
            this.botType ?? BotType.EASY,
        );
    }
}
